import { FC, useCallback } from 'react';

import { getFormattedIntNumber } from 'utils/clickme';
import { REMAINDER_BUDGETS_HEADERS, RemainderBudgetsHeaders } from 'utils/constants/admin';

import { Modal, Table, TableBody, TableCell, TableHeader, TableRow, Text } from '@hh.ru/magritte-ui';
import { CrossOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { MagritteModalHeader } from 'components/common/MagritteModalHeader/MagritteModalHeader';

import { setLoadCampaignAdminAction } from 'store/models/adminCampaignAction';
import { setVisibleRemainderBudgets } from 'store/models/remainderBudgets';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'campaign.info.sudo.actions.remainderBudgets',
    close: 'campaign.info.sudo.actions.remainderBudgets.close',
    headers: {
        [RemainderBudgetsHeaders.ApiSource]: 'campaign.info.sudo.actions.remainderBudgets.apiSource',
        [RemainderBudgetsHeaders.TotalAmount]: 'campaign.info.sudo.actions.remainderBudgets.totalAmount',
        [RemainderBudgetsHeaders.Remainder]: 'campaign.info.sudo.actions.remainderBudgets.remainder',
    },
};

export const RemainderBudgetsModal: FC = () => {
    const { isVisible, remainderBudgetsData } = useSelector((state) => state.remainderBudgets);
    const dispatch = useDispatch();
    const trls = useTrls();

    const handleCloseClick = useCallback(
        () => dispatch([setVisibleRemainderBudgets(false), setLoadCampaignAdminAction(false)]),
        [dispatch]
    );

    return (
        <Modal
            visible={isVisible}
            onClose={handleCloseClick}
            size="small"
            header={
                <MagritteModalHeader
                    title={trls(TrlKeys.title)}
                    size="small"
                    actions={
                        <CrossOutlinedSize24
                            initialColor="secondary"
                            onClick={handleCloseClick}
                            data-qa="change-history-modal-close"
                        />
                    }
                />
            }
        >
            <Table divider paddingLeft={0} paddingRight={0} cellsGap={16}>
                <TableHeader>
                    <TableRow align="left">
                        {REMAINDER_BUDGETS_HEADERS.map((header) => (
                            <TableCell key={header} Element="th" width={132}>
                                <Text style="secondary" typography="label-3-regular">
                                    {trls(TrlKeys.headers[header])}
                                </Text>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {remainderBudgetsData.map((item) => (
                        <TableRow key={item.apiSource}>
                            {REMAINDER_BUDGETS_HEADERS.map((header) => {
                                const itemValue = item[header];
                                return (
                                    <TableCell key={header} width={132}>
                                        <Text typography="label-3-regular">
                                            {typeof itemValue === 'number'
                                                ? getFormattedIntNumber(itemValue)
                                                : itemValue}
                                        </Text>
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Modal>
    );
};
